import {
    GRID_CHECKBOX_SELECTION_COL_DEF, GridRenderCellParams, GridRowSelectionModel,
} from '@mui/x-data-grid-pro'
import {
    MutableRefObject, useCallback, useMemo, useState, useRef,
} from 'react'
import {
    Checkbox,
} from '@mui/material'
import {
    ExtendedGridApiPro,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'
import {
    GridRadioCell,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/components'
import {
    INIT_SELECTION_MODEL,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/constants'
import {
    SelectionType,
} from 'app/PoC/DataGridDemoPages/components/SkyNetDataGrid/SkyNetDataGrid'

export default function useRowSelection({
    selectionType,
    apiRef,
    onSelectedRow,
    disabled,
    selectedRows,
    selectionModelType = 'include',
}: {
    selectionType: SelectionType,
    apiRef: MutableRefObject<ExtendedGridApiPro>,
    onSelectedRow?: (selectedIds: Set<string | number>) => void,
    disabled?: boolean,
    selectedRows?: (string | number)[],
    selectionModelType?: 'include' | 'exclude',
}) {
    const selectedRowsInit = useRef(selectedRows)

    const [
        selectionModel,
        setSelectionModel,
    ] = useState<GridRowSelectionModel>(() => {
        return {
            ...INIT_SELECTION_MODEL,
            type: selectionModelType,
            ids: new Set(selectedRowsInit.current),
        }
    })

    const toggleRowSelection = useCallback((id: number | string) => {
        const newSelection = {
            ...INIT_SELECTION_MODEL,
            type: selectionModelType,
            ids: new Set([id]),
        }

        apiRef.current.setRowSelectionModel(newSelection, 'singleRowSelection')
    }, [
        apiRef,
        selectionModelType,
    ])

    const onRowSelectionModelChange = useCallback((newSelectionModel: GridRowSelectionModel) => {
        setSelectionModel(newSelectionModel)
        onSelectedRow?.(newSelectionModel.ids)
    }, [onSelectedRow])

    const customRowSelectionColumn = useMemo(() => {
        return {
            ...GRID_CHECKBOX_SELECTION_COL_DEF,
            renderCell: (params: GridRenderCellParams) => {
                const checked = selectionModel.ids.has(params.id as number)

                if (selectionType === SelectionType.Radio) {
                    return (
                        <GridRadioCell
                            checked={checked}
                            disabled={disabled}
                            onChange={() => {
                                toggleRowSelection(params.id)
                            }}
                        />
                    )
                }

                return (
                    <Checkbox
                        checked={checked}
                        disabled={disabled}
                    />
                )
            },
        }
    }, [
        selectionModel.ids,
        selectionType,
        disabled,
        toggleRowSelection,
    ])

    return {
        selectionModel,
        customRowSelectionColumn,
        onRowSelectionModelChange,
    }
}
